/** "Add to home screen": native prompt where available, honest instructions on iPhone. */
import { useState } from 'react';
import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { Icon } from '@astryxdesign/core/Icon';
import { HStack, VStack } from '@astryxdesign/core/Layout';
import { Text } from '@astryxdesign/core/Text';
import { DeviceMobile, Export, PlusSquare } from '@phosphor-icons/react';
import { useInstallPrompt } from '@/lib/pwa.ts';
import { useTenant } from '@/app/tenant-context.ts';

export function InstallHint() {
  const { tenant } = useTenant();
  const install = useInstallPrompt();
  const [showIos, setShowIos] = useState(false);
  if (install.isInstalled || (!install.canPrompt && !install.needsIOSInstructions)) return null;
  return (
    <VStack paddingInline={4}>
      <Card variant="muted">
        <VStack gap={3}>
          <HStack gap={3} vAlign="center">
            <Icon icon={DeviceMobile} size="lg" color="accent" />
            <VStack gap={0.5}>
              <Text weight="semibold">Приложение {tenant.name}</Text>
              <Text type="supporting">Откроется с экрана «Домой» без адресной строки.</Text>
            </VStack>
          </HStack>
          {install.canPrompt ? (
            <Button label="Установить" variant="secondary" width="100%" clickAction={async () => void (await install.prompt())} />
          ) : showIos ? (
            <VStack gap={2}>
              <HStack gap={2} vAlign="center">
                <Icon icon={Export} />
                <Text>1. Нажмите «Поделиться» в Safari</Text>
              </HStack>
              <HStack gap={2} vAlign="center">
                <Icon icon={PlusSquare} />
                <Text>2. Выберите «На экран „Домой“»</Text>
              </HStack>
            </VStack>
          ) : (
            <Button label="Как установить на iPhone" variant="secondary" width="100%" onClick={() => setShowIos(true)} />
          )}
        </VStack>
      </Card>
    </VStack>
  );
}
